import React, {useEffect, useState, useContext} from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import {useHistory} from "react-router-dom";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import route from "./routes";
import {useSelector, useDispatch} from "react-redux";
import {get_all_users, get_all_groups, get_all_permisions} from '../redux/users';
import {SocketContext} from "../config/ws-client";
import {
    TYPE_UPDATE_MESSAGE,
    TYPE_CREATE_MESSAGE,
} from '../config/ws-client'
import {getAllProvinces} from "../redux/provinces";
import {getAllCities} from "../redux/cities";
import {getAllZones} from "../redux/zones";
import {getAllStores} from "../redux/stores";
import {getAllTeams} from "../redux/teams";
import {getAllUserTypes} from "../redux/user_types";
import {getAllPeriodicities} from "../redux/periodicities";
import {getAllCriticalLevels} from "../redux/critical_levels";
import {getAllWorkSheets} from "../redux/work_sheets";
import {getAllObservations} from "../redux/observations";
import {getAllResultStates} from "../redux/result_states";
import {getAllResponsibles} from "../redux/responsibles";
import {getAllFindingsMatrix} from "../redux/findings_matrix";
import {getAllSocieties} from "../redux/societies";
import {getAllUpdateActivity} from "../redux/update_activity";


const Index = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const _data_login = useSelector((state) => state.users_module.login);
    const _session_data = useSelector((state) => state.users_module._session_data);
    const [permisos, setPermissions] = useState([]);
    const {socket} = useContext(SocketContext);
    // const _get_notification = useSelector((state) => state.task_scheduled_module._get_notification);
    // eslint-disable-next-line
    const [token, setToken] = useState("")

    /* const audio = new Audio("/base/assets/audio/audio.mp3"); */

    var day = new Date().getDate();
    var month = new Date().getMonth() + 1;
    var year = new Date().getFullYear();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    var date = year + '-' + month + '-' + day;

    useEffect(() => {
        if (JSON.stringify(_session_data.data) !== "{}") {
            if (_session_data.data.grupo_permiso) {
                if (_session_data.data.grupo_permiso.permisos) {
                    setPermissions(_session_data.data.grupo_permiso.permisos);
                }
            }
        }
    }, [_session_data]);

    useEffect(() => {
        if (_data_login.status >= 200) {
            if (permisos.filter(x => x.codigo === 'view_user').length > 0) {
                dispatch(get_all_users(_data_login.data.token));
                dispatch(get_all_permisions(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_group').length > 0) {
                dispatch(get_all_groups(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_provinces').length > 0) {
                dispatch(getAllProvinces(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_cities').length > 0) {
                dispatch(getAllCities(_data_login.data.token));
            }
            if (permisos.filter(x => (x.codigo === 'view_zones' || x.codigo === 'view_activities')).length > 0) {
                dispatch(getAllZones(_data_login.data.token));
            }
            if (permisos.filter(x => (x.codigo === 'view_stores' || x.codigo === 'view_activities')).length > 0) {
                dispatch(getAllStores(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_teams').length > 0) {
                dispatch(getAllTeams(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_criticallevels').length > 0) {
                dispatch(getAllCriticalLevels(_data_login.data.token));
            }
            if (permisos.filter(x => (x.codigo === 'view_worksheets' || x.codigo === 'view_activities')).length > 0) {
                dispatch(getAllWorkSheets(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_periodicities').length > 0) {
                dispatch(getAllPeriodicities(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_observations').length > 0) {
                dispatch(getAllObservations(_data_login.data.token));
            }
            if (permisos.filter(x => (x.codigo === 'view_resultstates' || x.codigo === 'view_activities')).length > 0) {
                dispatch(getAllResultStates(_data_login.data.token));
            }
            if (permisos.filter(x => (x.codigo === 'view_responsibles' || x.codigo === 'view_activities')).length > 0) {
                dispatch(getAllResponsibles(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_findingsmatrix').length > 0) {
                dispatch(getAllFindingsMatrix(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_societies').length > 0) {
                dispatch(getAllSocieties(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'aprobar_solicitud_edicion').length > 0) {
                dispatch(getAllUpdateActivity(_data_login.data.token));
            }
            dispatch(getAllUserTypes(_data_login.data.token));
            setToken(_data_login.data.token);
        } else {
            history.push("/");
        }
    }, [dispatch, _data_login, history, date, permisos]);


    useEffect(() => {
        handleMessageWs();
        // eslint-disable-next-line
    }, [socket])

    // const sleep = (ms) => {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }


    const handleMessageWs = () => {
        if (socket) {
            socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.type === TYPE_UPDATE_MESSAGE) {
                    update_message(data, socket)
                    return;
                }

                if (data.type === TYPE_CREATE_MESSAGE) {
                    create_message(data, socket)
                }
            }
        }
    }


    const update_message = (data, socket) => {
        // toast.success(data.message);
        //
        // const notification = {
        //     title: data.title,
        //     message: data.message,
        //     result: null,
        //     id: data.id,
        //     read: false,
        //     type: TYPE_UPDATE_MESSAGE,
        //     show: true,
        //     date: data.date
        // }
        // let n = _get_notification.data ?? [];
        // n.push(notification)
        // audio.play();
    }

    const create_message = (data, socket) => {
        dispatch(getAllUpdateActivity(token));
    }

    return (
        <Router>
            <div className="header-navbar-shadow"/>
            <Navbar/>
            <Sidebar/>
            <Switch>
                {/* eslint-disable-next-line*/}
                {route.map((item, index) => {
                    if (!item.meta.requiresAuth) {
                        return (
                            <Route path={item.path} exact={item.exact}>
                                {<item.component {...permisos} />}
                            </Route>
                        );
                    }
                    if (permisos.filter(x => item.meta.permission_required.includes(x.codigo)).length > 0) {
                        return (
                            <Route path={item.path} exact={item.exact}>
                                {<item.component {...permisos} />}
                            </Route>
                        );
                    }
                })}
            </Switch>

        </Router>
    );
};
export default Index;
